// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"5a967322","479":"6d90bff0","488":"31a3a1a0","910":"3b1c03f0","919":"996ed14a","994":"bf9884af"}[chunkId] + ".chunk.js";
};